import { twMerge } from 'tailwind-merge';

export const Background = ({ className }: { className?: string }) => (
  <div className={twMerge('bg-surface-light', className)} />
);
